import React from 'react';

import './style.scss';

const Hamburger = ({ handleClick, icon = false }) => (
  <div className="Hamburger" onClick={handleClick}>
    <div className="bars">
      <span className="icon-bar" />
      <span className="icon-bar" />
      <span className="icon-bar" />
    </div>
    { icon && (
      <i className="icon icon-menu-search icon-variant-4" />
    )}
  </div>
);

export default Hamburger;
